var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "pa-0", attrs: { "grid-list-sm": "", fluid: "" } },
        [
          _c(
            "v-form",
            { ref: "unitary_form" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs2: "" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ml-2 background--text text--lighten-5 subheading"
                        },
                        [_vm._v("\n\t\t\t\t\t\tType *\n\t\t\t\t\t")]
                      ),
                      _vm._v(" "),
                      _c("v-autocomplete", {
                        staticClass: "mb-3 grv-input",
                        attrs: {
                          solo: "",
                          dense: "",
                          rules: [_vm.required],
                          name: "Package type",
                          "menu-props": { contentClass: "grv-menu" },
                          clearable: "",
                          items: _vm.package_types
                        },
                        model: {
                          value: _vm.form.parameters.package_type,
                          callback: function($$v) {
                            _vm.$set(_vm.form.parameters, "package_type", $$v)
                          },
                          expression: "form.parameters.package_type"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs6: "" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ml-2 background--text text--lighten-5 subheading"
                        },
                        [_vm._v("\n\t\t\t\t\t\tTitre *\n\t\t\t\t\t")]
                      ),
                      _vm._v(" "),
                      _c("v-text-field", {
                        staticClass: "mb-3 grv-input",
                        attrs: {
                          solo: "",
                          name: "Title",
                          clearable: "",
                          rules: [_vm.required]
                        },
                        model: {
                          value: _vm.form.parameters.title,
                          callback: function($$v) {
                            _vm.$set(_vm.form.parameters, "title", $$v)
                          },
                          expression: "form.parameters.title"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs4: "" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ml-2 background--text text--lighten-5 subheading"
                        },
                        [_vm._v("\n\t\t\t\t\t\tLabel *\n\t\t\t\t\t")]
                      ),
                      _vm._v(" "),
                      _c("v-text-field", {
                        staticClass: "mb-3 grv-input",
                        attrs: {
                          solo: "",
                          name: "Label",
                          clearable: "",
                          rules: [_vm.required]
                        },
                        model: {
                          value: _vm.form.parameters.label,
                          callback: function($$v) {
                            _vm.$set(_vm.form.parameters, "label", $$v)
                          },
                          expression: "form.parameters.label"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", "align-end": "" } },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "background--text text--lighten-5 subheading ml-2"
                    },
                    [
                      _vm._v("\n\t\t\t\t\tSélection des assets\n\t\t\t\t\t"),
                      _vm.nbAssets > 0
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "my-0",
                              attrs: {
                                label: "",
                                small: "",
                                outline: "",
                                color: "primary"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.nbAssets) +
                                  " selectionnés\n\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.nbAssets > 0
                    ? _c(
                        "v-btn",
                        {
                          ref: "removeFiles_btn",
                          staticClass: "my-0 mx-1 color--text text-none",
                          attrs: { color: "warning", small: "" },
                          on: {
                            click: function($event) {
                              _vm.form.parameters.assets.list = []
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("close")
                          ]),
                          _vm._v("\n\t\t\t\t\tSuppprimer les assets\n\t\t\t\t")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("v-text-field", {
                staticStyle: {
                  visibility: "hidden",
                  height: "0",
                  padding: "0"
                },
                attrs: { name: "Assets", rules: [_vm.assetsCheck] },
                model: {
                  value: _vm.form.parameters.assets.list,
                  callback: function($$v) {
                    _vm.$set(_vm.form.parameters.assets, "list", $$v)
                  },
                  expression: "form.parameters.assets.list"
                }
              }),
              _vm._v(" "),
              _vm.nbAssets > 0
                ? _c(
                    "div",
                    _vm._l(_vm.form.parameters.assets.list, function(
                      asset,
                      assetIndex
                    ) {
                      return _c(
                        "div",
                        {
                          key: asset.filepath,
                          staticClass: "asset-section elevation-4"
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "caption d-block" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  attrs: { flat: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeAsset(assetIndex)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("close")])],
                                1
                              ),
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(asset.filepath) +
                                  "\n\t\t\t\t\t"
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs2: "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "ml-2 background--text text--lighten-5"
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tType\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-autocomplete", {
                                    staticClass: "grv-input-dense grv-input",
                                    attrs: {
                                      solo: "",
                                      dense: "",
                                      "menu-props": {
                                        contentClass: "grv-menu"
                                      },
                                      rules: [_vm.required],
                                      name: "Asset type #" + assetIndex,
                                      clearable: "",
                                      items: _vm.asset_types
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onAssetTypeChange(assetIndex)
                                      }
                                    },
                                    model: {
                                      value: asset.asset_type,
                                      callback: function($$v) {
                                        _vm.$set(asset, "asset_type", $$v)
                                      },
                                      expression: "asset.asset_type"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs2: "" } },
                                [
                                  _vm.showRole(asset.asset_type)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ml-2 background--text text--lighten-5"
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\tRôle\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showRole(asset.asset_type)
                                    ? _c("v-autocomplete", {
                                        staticClass:
                                          "grv-input-dense grv-input",
                                        attrs: {
                                          solo: "",
                                          dense: "",
                                          rules: [],
                                          name: "Asset role #" + assetIndex,
                                          "menu-props": {
                                            contentClass: "grv-menu"
                                          },
                                          clearable: "",
                                          items: _vm.asset_roles
                                        },
                                        model: {
                                          value: asset.role,
                                          callback: function($$v) {
                                            _vm.$set(asset, "role", $$v)
                                          },
                                          expression: "asset.role"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              asset.asset_type
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs5: "" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ml-2 background--text text--lighten-5"
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\tLangue\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-autocomplete", {
                                        staticClass:
                                          "grv-input-dense grv-input input-lg",
                                        attrs: {
                                          clearable: "",
                                          solo: "",
                                          rules: [],
                                          "menu-props": {
                                            contentClass: "grv-menu"
                                          },
                                          dense: "",
                                          name: "Asset language #" + assetIndex,
                                          items: _vm.languages,
                                          "item-text": "text",
                                          "item-value": "code"
                                        },
                                        model: {
                                          value: asset.language,
                                          callback: function($$v) {
                                            _vm.$set(asset, "language", $$v)
                                          },
                                          expression: "asset.language"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs3: "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "ml-2 background--text text--lighten-5"
                                    },
                                    [
                                      asset.asset_type === "Audio"
                                        ? _c("span", [_vm._v("Audio Type")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      asset.asset_type === "Subtitle"
                                        ? _c("span", [_vm._v("Subtitle Type")])
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  asset.asset_type === "Audio"
                                    ? _c("v-autocomplete", {
                                        staticClass:
                                          "grv-input-dense grv-input",
                                        attrs: {
                                          solo: "",
                                          dense: "",
                                          clearable: "",
                                          rules: [],
                                          "menu-props": {
                                            contentClass: "grv-menu"
                                          },
                                          name:
                                            "Asset audio type #" + assetIndex,
                                          items: _vm.audio_types
                                        },
                                        model: {
                                          value: asset.audio_type,
                                          callback: function($$v) {
                                            _vm.$set(asset, "audio_type", $$v)
                                          },
                                          expression: "asset.audio_type"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  asset.asset_type === "Subtitle"
                                    ? _c("v-autocomplete", {
                                        staticClass:
                                          "grv-input-dense grv-input",
                                        attrs: {
                                          solo: "",
                                          dense: "",
                                          clearable: "",
                                          rules: [],
                                          "menu-props": {
                                            contentClass: "grv-menu"
                                          },
                                          name:
                                            "Asset subtitle type #" +
                                            assetIndex,
                                          items: _vm.subtitle_types
                                        },
                                        model: {
                                          value: asset.subtitle_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              asset,
                                              "subtitle_type",
                                              $$v
                                            )
                                          },
                                          expression: "asset.subtitle_type"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "mt-3 mb-0" },
                [
                  _c(
                    "v-btn",
                    {
                      ref: "explorer_btn",
                      staticClass: "mt-0 mx-1 color--text text-none",
                      attrs: { color: "primary", small: "" },
                      on: {
                        click: function($event) {
                          _vm.show_explorer = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v("\n\t\t\t\t\tFichiers via le filesystem\n\t\t\t\t")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      ref: "asset_finder_btn",
                      staticClass: "mt-0 mx-1 color--text text-none",
                      attrs: { color: "primary", small: "" },
                      on: {
                        click: function($event) {
                          _vm.show_asset_finder = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v("\n\t\t\t\t\tFichiers via asset finder\n\t\t\t\t")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "SuifaOFDialog",
                    {
                      on: {
                        "suifa-asset-selected": function($event) {
                          return _vm.onSuifaAssetSlected($event)
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("download")
                      ]),
                      _vm._v("\n\t\t\t\t\tAssets fab SUIFA\n\t\t\t\t")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.debug
        ? _c(
            "v-card",
            { staticClass: "pa-2 mb-3" },
            [
              _c("tree-view", {
                attrs: {
                  data: _vm.form,
                  options: { maxDepth: 3, rootObjectKey: "Output" }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.debug
        ? _c(
            "v-card",
            { staticClass: "pa-2" },
            [
              _c("tree-view", {
                attrs: {
                  data: _vm.wf_data,
                  options: { maxDepth: 0, rootObjectKey: "Job Descriptor" }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.show_explorer
        ? _c("Explorer", {
            attrs: {
              assetType: "file",
              multiselect: true,
              toolbarTitle: "Selectionnez des assets présents sur le filesystem"
            },
            on: {
              close: function($event) {
                _vm.show_explorer = false
              },
              selectedAssets: function($event) {
                return _vm.addAssetsFromFinders($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.show_asset_finder
        ? _c("AssetFinder", {
            attrs: {
              multiselect: true,
              toolbarTitle: "Selectionnez des assets via asset finder"
            },
            on: {
              close: function($event) {
                _vm.show_asset_finder = false
              },
              selectedAssets: function($event) {
                return _vm.addAssetsFromFinders($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b30e75e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b30e75e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/forms/launcher_form_xbox_package.vue
// module id = null
// module chunks = 